import { render } from "./unreadTopic.vue?vue&type=template&id=c88f884c"
import script from "./unreadTopic.vue?vue&type=script&lang=js"
export * from "./unreadTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__